import React, { createContext, useContext, useEffect, useState } from "react";
import { useApiService } from "../shared/apiservice";
import { StockLevelWarning } from "../shared/types";

const stockLevelWarningsContext = createContext<{
    stockLevelWarnings: StockLevelWarning[];
    loading: boolean;
    total: number;
    setPerPage: (perPage: number) => void;
}>({
    stockLevelWarnings: [],
    loading: false,
    total: 0,
    setPerPage: () => { },
});

function useProviderStockLevelWarnings() {
    const [stockLevelWarnings, setStockLevelWarnings] = useState<StockLevelWarning[]>([]);
    const [loading, setLoading] = useState(false);
    const [perPage, setPerPage] = useState(10);
    const [total, setTotal] = useState(0);
    const apiService = useApiService();

    useEffect(() => {
        async function fetchStockLevelWarnings() {
            setLoading(true);
            try {
                const response = await apiService.get(`/stock/warnings/level?per_page=${perPage}`);
                if (!response.ok) return;

                const json = await response.json();
                const warnings: StockLevelWarning[] = json.data ?? json;
                setStockLevelWarnings(warnings);
                setTotal(json.meta?.total ?? warnings.length);
            } catch (error) {
                console.error(error);
            } finally {
                setLoading(false);
            }
        }

        fetchStockLevelWarnings();
    }, [perPage]);

    return { stockLevelWarnings, loading, total, setPerPage };
}

export function ProviderStockLevelWarnings({ children }: { children: React.ReactNode }) {
    const stockLevelWarnings = useProviderStockLevelWarnings();
    return <stockLevelWarningsContext.Provider value={stockLevelWarnings}>{children}</stockLevelWarningsContext.Provider>;
}

export const useStockLevelWarnings = () => useContext(stockLevelWarningsContext);
